import { Sparkles, X } from "lucide-react";

export const ConciergeOrb = ({ open, onToggle, label }) => {
  return (
    <button
      type="button"
      onClick={onToggle}
      data-testid="concierge-orb-button"
      aria-label={label}
      aria-expanded={open}
      className="fixed bottom-6 right-6 z-40 group"
    >
      <div className="relative">
        <div
          className={`absolute inset-0 rounded-full bg-cyan-400 blur-xl transition-opacity duration-500 ${
            open ? "opacity-40" : "opacity-60 animate-pulse-glow"
          }`}
        />
        <div
          className={`relative w-14 h-14 rounded-full flex items-center justify-center shadow-lg transition-all duration-300 group-hover:scale-110 ${
            open
              ? "bg-slate-900 border border-cyan-400/60 text-cyan-300"
              : "bg-gradient-to-br from-cyan-300 to-cyan-500 text-slate-950"
          }`}
        >
          {open ? <X className="w-6 h-6" /> : <Sparkles className="w-6 h-6" />}
        </div>
      </div>
    </button>
  );
};

export default ConciergeOrb;
